import { Brand } from "../../../models/brand.model.ts";
import { BrandSerializer } from "../../../models/serializers/brandSerializer.ts";
import { httpRequest } from "../../http";

/** The brand info and editorial columns the PATCH owns. The rest stay on the multipart POST. */
export const BRAND_PATCH_FIELDS = [
    "display_name",
    "guidelines_url",
    "demographics",
    "capitalization",
    "oxford_comma",
    "em_dash_spaces",
    "ampersand_for_and",
    "key_terms",
    "brand_notes",
    "preferred_date_format",
] as const;

export type BrandPatchField = (typeof BRAND_PATCH_FIELDS)[number];

/** Only the keys sent change; null clears one. */
export type BrandPatch = Partial<Record<BrandPatchField, string | boolean | null>>;

export class CommandPatchOrganizationBrand {
    async run(organizationId: string, brandId: string, changes: BrandPatch): Promise<Brand> {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/organizations/${organizationId}/brands/${brandId}`;
        const response = await httpRequest<any>(url, { method: "PATCH", body: changes });
        return new BrandSerializer().deserialize(response);
    }
}
